
module.exports = function config () {
    throw new Error(
        'this should have been compiled away by rs-config-loader, ' +
        'is it set up correctly?',
    );
};

